// The four tabs: Catches, Map, Groups and More.
import type { TextKey } from "../shared/strings.ts";
import { $ } from "./dom.ts";
import { t } from "./i18n.ts";
import { setMapFull, showMap } from "./map/bigmap.ts";
import { storageInfo } from "./backup.ts";
import { lsGet, lsSet } from "./util.ts";

export const VIEWS = ["log", "map", "groups", "more"] as const;
export type View = (typeof VIEWS)[number];
const TITLES: Record<View, TextKey> = { log: "viewLog", map: "viewMap", groups: "viewGroups", more: "viewMore" };
const isView = (v: string): v is View => (VIEWS as readonly string[]).includes(v);

const saved = lsGet("view", "log");
/** The tab on screen. */
export let view: View = isView(saved) ? saved : "log";

export function setView(v: View): void {
  view = v;
  lsSet("view", v);
  $(".app").dataset.view = v;
  if (v !== "map") setMapFull(false);
  for (const s of VIEWS) $("#v-" + s).hidden = s !== v;
  document.querySelectorAll<HTMLElement>(".tab[data-view]").forEach((b) => {
    if (b.dataset.view === v) b.setAttribute("aria-current", "page"); else b.removeAttribute("aria-current");
  });
  showTitle();
  if (v === "map") showMap();
  if (v === "more") void storageInfo();
}
/** The heading of the current tab (also after the language changes). */
export function showTitle(): void {
  $("#view-title").textContent = t(TITLES[view]);
}
document.querySelectorAll<HTMLElement>(".tab[data-view]").forEach((b) => b.addEventListener("click", () => {
  const v = b.dataset.view ?? "";
  if (isView(v)) setView(v);
}));
